/* jt-cart-empty-cta */
(function () {
  var maps = {"de":"Unsere Produkte ansehen","fr":"Voir nos produits","en":"View our products","it":"Vedi i nostri prodotti","es":"Ver nuestros productos","pl":"Zobacz nasze produkty","pt":"Ver os nossos produtos"};
  var loc = String((window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase().split('-')[0];
  var path = (window.location && window.location.pathname) || '';
  if (!maps[loc]) {
    for (var code in maps) {
      if (new RegExp('^\\/' + code + '(\\/|$)').test(path)) { loc = code; break; }
    }
  }
  if (!maps[loc]) return;
  var next = maps[loc];
  var re = /Bekijk onze producten|View our products|Siehe unsere Produkte|Unsere Produkte ansehen/i;
  function fix() {
    document.querySelectorAll('a, button, .button, [class*="empty"]').forEach(function (el) {
      var txt = (el.textContent || '').trim();
      if (re.test(txt) || txt === 'Bekijk onze producten') {
        if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) el.textContent = next;
        else {
          var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
          var n;
          while ((n = tw.nextNode())) {
            if (n.nodeValue && /Bekijk onze producten/i.test(n.nodeValue)) {
              n.nodeValue = n.nodeValue.replace(/Bekijk onze producten/gi, next);
            }
          }
        }
      }
    });
  }
  function boot() {
    fix();
    [100, 400, 1000, 2500, 5000, 10000].forEach(function (ms) { setTimeout(fix, ms); });
    /* MO removed freeze-v3 */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* jt-cart-empty-cta-bust:1785232600474 */

/* jt-bestellen-via-logo */
(function () {
  var path = (window.location && window.location.pathname) || '';
  if (!/bestellen-betalen-service/i.test(path)) return;
  var SRC = 'https://jt-products.eu/cdn/shop/files/Hulp_nodig_bij_je_bestelling_webp.webp?v=1779373439&width=800';
  var ALT = {
    de: 'Hilfe bei Ihrer Bestellung',
    fr: "Besoin d'aide pour votre commande",
    en: 'Need help with your order',
    it: 'Hai bisogno di aiuto con il tuo ordine',
    es: 'Necesitas ayuda con tu pedido',
    pl: 'Potrzebujesz pomocy przy skladaniu zamowienia?',
    pt: 'Precisa de ajuda com a sua encomenda?',
    nl: 'Hulp nodig bij je bestelling'
  };
  function code() {
    var l = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
    return ALT[l] ? l : 'nl';
  }
  function fix() {
    document.querySelectorAll('.image-with-text__image-container').forEach(function (box) {
      var ph = box.querySelector('svg.placeholder-svg');
      var img = box.querySelector('img');
      var src = img && img.getAttribute('src');
      if (src && /Hulp_nodig_bij_je_bestelling_webp/i.test(src)) return;
      var el = document.createElement('img');
      el.src = SRC;
      el.alt = ALT[code()] || ALT.nl;
      el.loading = 'lazy';
      el.setAttribute('width', '800');
      if (ph) ph.replaceWith(el);
      else if (img) { img.src = SRC; img.alt = ALT[code()] || ALT.nl; }
      else box.appendChild(el);
    });
  }
  function boot() {
    fix();
    [50, 200, 600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(fix, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* jt-bestellen-via-logo-bust:1785236808070 */

/* jt-freeze-fix-v3 1785685672751 */

/* Normalize encoded punctuation in cart titles without interpreting HTML. */
(function () {
  var selector = '.mini-cart__product-title, .line-item__title';
  var decoder = document.createElement('textarea');
  function decodeTitle(value) {
    for (var pass = 0; pass < 3; pass++) {
      var next = value.replace(/&(?:#[0-9]{1,7}|#x[0-9a-f]{1,6}|[a-z][a-z0-9]{1,31});/gi, function (entity) {
        decoder.innerHTML = entity;
        return decoder.value;
      });
      if (next === value) break;
      value = next;
    }
    return value;
  }
  function clean(root) {
    if (!root || root.nodeType !== 1) return;
    var titles = root.matches(selector) ? [root] : root.querySelectorAll(selector);
    Array.prototype.forEach.call(titles, function (title) {
      var walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var value = decodeTitle(node.nodeValue);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    });
  }
  function boot() {
    ['#mini-cart', '[data-section-type="cart"]'].forEach(function (selector) {
      var root = document.querySelector(selector);
      if (!root) return;
      clean(root);
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.type === 'characterData') {
            var title = record.target.parentElement && record.target.parentElement.closest('.mini-cart__product-title, .line-item__title');
            if (title) clean(title);
          } else {
            record.addedNodes.forEach(function (node) {
              if (node.nodeType === 3) {
                var title = node.parentElement && node.parentElement.closest('.mini-cart__product-title, .line-item__title');
                if (title) clean(title);
              } else clean(node);
            });
          }
        });
      }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
